import { createFileRoute } from "@tanstack/react-router";
import Insights from "@/pages/Insights";
import { fetchInsightsSsrData } from "@/lib/insightsSsrData";
import { pageHead } from "@/lib/pageHead";

export const Route = createFileRoute("/en/insights/")({
  head: () => pageHead("insights", "en", { links: false }),
  loader: () => fetchInsightsSsrData(),
  component: EnInsightsRoute,
  errorComponent: () => <Insights />,
  notFoundComponent: () => <Insights />,
});


function EnInsightsRoute() {
  const data = Route.useLoaderData();
  return <Insights initialArticles={data.articles} initialCategories={data.categories} />;
}
